"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault"),
    _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react")),
    _CollaboratorsList = _interopRequireDefault(require("./CollaboratorsList"));

function AddTeamsTab(a) {
  var b = a.teams,
      c = a.onAddMember,
      d = a.membersIds,
      e = a.loading;
  return _react["default"].createElement(_CollaboratorsList["default"], {
    listItems: b,
    type: "teams",
    onAddMember: c,
    membersIds: d,
    loading: e
  });
}

var _default = (0, _react.memo)(AddTeamsTab);

exports["default"] = _default;